/**=========================================================
 * Module: dashboard.js
 * Dashboard Controller
 =========================================================*/

App.controller('DashboardController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', 'toaster', '$filter', 'ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, toaster, $filter, ngDialog) {
    "use strict";

    $scope.page = {
        title: 'labels.DASHBOARD',
        subTitle: 'labels.WELCOME',
        subTitleParams: { appName: $rootScope.app.name }
    }

    let includedFields = 'id,toDo,toBeAssigned,assignee,assigneeName,ownerName,urgentOffer,offerDeadlineHasTime,offerDeadlineWithTime,name,owner,delivery,code,status,source,proposedDate,translationStatus,tS,group,languages,suppliersNames,opts,hasReview,destinations,T,standby'

    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    var replaceQueryString = function(url, param, value) {
        var re = new RegExp("([?|&])" + param + "=.*?(&|$)", "i");
        if (url.match(re))
            return url.replace(re, '$1' + param + "=" + value + '$2');
        else{
            if(url.indexOf('?')<0){
                return url + '?' + param + "=" + value;
            } else {
                return url + '&' + param + "=" + value;
            }
        }
    }
    var removeNullParam = function(url, key){
        url = url.replace('?'+key+'=&','?')
        url = url.replace('?'+key+'=','?')
        url = url.replace('&'+key+'=','')
        if(url.indexOf('?', url.length - '?'.length) !== -1) url = url.substr(0, url.length-1)
        return url
      }
    var changeUrl = function(q){
        var url = ''+window.location.href
        for(var key in q){
            url = replaceQueryString(url, key, q[key])
            if(q[key]===''){
                url = removeNullParam(url, key)    
            }
        }
        if(url!=window.location.href){
            window.history.pushState(q, '', url)
        }
    }

    var parseQuery =function(href) {
        var queryString = href.substr(href.indexOf('?')+1)
        if(href.indexOf('?')<0) queryString = ''
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }
    
    var onPopstate = function (event) {
        var newFilter = parseQuery(window.location.href).filter
        if($rootScope.dashboard.projectFilter!=newFilter){
            $rootScope.dashboard.projectFilter = newFilter
            $scope.init(new Date().getTime());
        }
    }
    window.addEventListener('popstate', onPopstate);

    $rootScope.dashboard.projectFilter = parseQuery(window.location.href).filter
    $scope.setProjectFilter = function(f){
        $rootScope.dashboard.projectFilter = f;
        changeUrl({filter:f})
        $scope.init(new Date().getTime());
    }
    
    var T = null

    $scope.init = function(t){
        T = t
        if(!$scope.initialized && !$scope.watchActivated){
            $scope.watchActivated = true;
            $rootScope.$watch('user.id', function(){
                if(!$scope.initialized){
                    $scope.init(new Date().getTime());
                }
            });
        }

        if($rootScope.user.id){
            if(!$rootScope.dashboard.projectFilter){
                if($rootScope.user.admin){
                    $rootScope.dashboard.projectFilter = 'own';
                }
                if($rootScope.user.groupType=='CLIENT' && $rootScope.user.superUser){
                    $rootScope.dashboard.projectFilter = $rootScope.user.opts.dashboardfilter;
                }
            }

            $scope.initialized = true;

            if($rootScope.user.customRole == 'REVIEWER'){
                $state.go('app.entity', {action: 'list', type: 'reviews', filter: ''})
            }

            $scope.currentDate = new Date().getTime() + 43200000;
            
            $scope.openProjectsTable = {
                link: {
                	state: 'app.do',
                    action: 'open',
                    type: 'project',
                    filter: 'id'
                },
                loading: true
            };

            $scope.runningProjectsTable = {
                    link: {
                    	state: 'app.do',
                        action: 'open',
                        type: 'project',
                        filter: 'id'
                    },
                    loading: true
                };

            $scope.closedProjectsTable = {
                    link: {
                    	state: 'app.do',
                        action: 'open',
                        type: 'project',
                        filter: 'id'
                    },
                    loading: true
                };

            var filters = {};
            if($rootScope.user.groupType=='CLIENT'){
            	filters.open = 'statusgroup=open'+($rootScope.dashboard.projectFilter=='own' ? '&_superUserOwn=true' : '');//'status=DRAFT|SENT|ANALYSIS|ESTIMATION|REVISION';
            	filters.running = 'statusgroup=running'+($rootScope.dashboard.projectFilter=='own' ? '&_superUserOwn=true' : '');//'status=CONFIRMED|PROCESSING';
            	filters.closed = 'status=DELIVERED'+($rootScope.dashboard.projectFilter=='own' ? '&_superUserOwn=true' : '');//'status=DELIVERED';
            } else if($rootScope.user.groupType=='ADMIN'){
            	filters.open = 'statusgroup=open'+($rootScope.dashboard.projectFilter=='own' ? '&assignee='+$rootScope.user.id : '');//'status=DRAFT|SENT|ANALYSIS|ESTIMATION|REVISION';
            	filters.running = 'statusgroup=running'+($rootScope.dashboard.projectFilter=='own' ? '&assignee='+$rootScope.user.id : '');//'status=CONFIRMED|PROCESSING';
            	filters.closed = 'status=DELIVERED'+($rootScope.dashboard.projectFilter=='own' ? '&assignee='+$rootScope.user.id : '');//'status=DELIVERED';
            } else if($rootScope.user.groupType=='SUPPLIER'){
            	filters.open = '_status=open';//'status=ESTIMATION';
            	filters.running = '_status=running';//'status=CONFIRMED|PROCESSING';
            	filters.closed = '_status=closed';//'status=DELIVERED|STOPPED';
            }

            $rootScope.dashboard.removeDuplicatesAndSort = function(originalArray) {
                let statusValue = function(s){
                    var v = -1;
                    switch (s) {
                        case 'DRAFT': v = 1; break;
                        case 'SENT': v = 2; break;
                        case 'ANALYSIS': v = 3; break;
                        case 'REVISION': v = 4; break;
                        case 'ESTIMATION': v = 5; break;
                        case 'CONFIRMED': v = 6; break;
                        case 'PROCESSING': v = 7; break;
                        case 'DELIVERED': v = 8; break;
                        /*case 'STOPPED': v = 1; break;
                        case 'NOTCONFIRMED': v = 1; break;
                        case 'ARCHIVED': v = 1; break;*/
                        default: 10
                    }
                    return v;
                }
                let sortByT = function(a, b){
                    if(a.toBeAssigned===true && b.toBeAssigned===false) return -1;
                    if(a.toDo===false && b.toDo===true) return 1;
                    if(a.toDo===true && b.toDo===false) return -1;
                    if(a.toBeAssigned===false && b.toBeAssigned===true) return 1;
                    if(statusValue(a.status)<statusValue(b.status)) return -1;
                    if(statusValue(a.status)>statusValue(b.status)) return 1;
                    if(a.T<b.T) return 1;
                    if(a.T>b.T) return -1;
                    return 0;
                }

                var newArray = [];
                var lookupObject  = {};
           
                for(var i in originalArray) {
                    let id = originalArray[i].id
                    if(lookupObject[id]){
                        if(lookupObject[id].T<originalArray[i].T){
                            lookupObject[id] = originalArray[i]
                        }
                    } else {
                        lookupObject[id] = originalArray[i];
                    }
                }
           
                for(i in lookupObject) {
                    newArray.push(lookupObject[i]);
                }
                 return newArray.sort(sortByT);
            }

            

            $rootScope.dashboard.modifyProject = function(p){
                let getLanguagesString = function(destinations, options){
                    options = options || {}
                    var langArray = []
                    for(var j=0; j<destinations.length; j++){
                        langArray.push($filter('translate')('enums.language.'+destinations[j]));
                    }
                    langArray.sort()
                    if(options.model) options.model.orderedLanguages = langArray
                    return langArray.join(options.sep || ', ')
                }

                p.languages = $filter('translate')('enums.language.'+p.source) + ' > ' + getLanguagesString(p.destinations, { model: p });
                p.recent = new Date().getTime() - p.T < 30000;

                if($rootScope.user.admin){
                    p.tS = []
                    var tStatuses = [ 'TRANSLATION', 'IMPORT', 'LAYOUT', 'REVIEW', 'REVISION', 'DELIVERED' ]
                    var inC = [0, 0, 0, 0, 0]
                    for(var lang in p.tStatus){
                        inC[tStatuses.indexOf(p.tStatus[lang])]++
                        p.tS.push({lang: lang,status: p.tStatus[lang]})
                    }
                    for(var j in tStatuses){
                        if(inC[j]>0 && (tStatuses[j]=='TRANSLATION' || tStatuses[j]=='LAYOUT' || tStatuses[j]=='REVIEW')) { p.translationStatus = tStatuses[j]; break; }
                    }
                }

                return p
            }

            
            $rootScope.dashboard.onResponseOpen = function(response){
                if(response.streamCallN==0){
                    $rootScope.dashboard.dataOpen = [];
                    $rootScope.dashboard.dataOpenStandby = [];
                    if($scope && $scope.openProjectsTable) $scope.openProjectsTable.loading = true;
                }
                for(var i=0; i<response.length; i++){
                    response[i] = $rootScope.dashboard.modifyProject(response[i])
                    if(response[i].standby){
                        $rootScope.dashboard.dataOpenStandby.push(response[i]);
                    } else {
                        $rootScope.dashboard.dataOpen.push(response[i]);
                    }
                    if(response[i].toDo) $rootScope.dashboard.thereAreToDoOpenProjects = true;
                }

                if(response.finished) { 
                    $rootScope.dashboard.openProjects = $rootScope.dashboard.removeDuplicatesAndSort($rootScope.dashboard.dataOpen);
                    $rootScope.dashboard.openProjectsStandby = $rootScope.dashboard.removeDuplicatesAndSort($rootScope.dashboard.dataOpenStandby);
                    if($scope && $scope.openProjectsTable) $scope.openProjectsTable.loading = false;
                    if(FIREBASE.dashboardFilters['openUnassigned']) D.stream('project', FIREBASE.dashboardFilters['openUnassigned'], $rootScope.dashboard.onResponseOpenUnassigned)
                }
            }

            $rootScope.dashboard.onResponseOpenUnassigned = function(response){
                for(var i=0; i<response.length; i++){
                    response[i] = $rootScope.dashboard.modifyProject(response[i])
                    $rootScope.dashboard.openProjects.push(response[i]);
                    $rootScope.dashboard.openProjects = $rootScope.dashboard.removeDuplicatesAndSort($rootScope.dashboard.openProjects)
                }
            }

            $rootScope.dashboard.onResponseRunning = function(response){
                if(response.streamCallN==0){
                    $rootScope.dashboard.dataRunning = [];
                    $rootScope.dashboard.dataRunningStandby = [];
                    if($scope && $scope.runningProjectsTable) $scope.runningProjectsTable.loading = true;
                }
                for(var i=0; i<response.length; i++){
                    response[i] = $rootScope.dashboard.modifyProject(response[i])
                    if(response[i].standby){
                        $rootScope.dashboard.dataRunningStandby.push(response[i]);
                    } else {
                        $rootScope.dashboard.dataRunning.push(response[i]);
                    }
                    if(response[i].toDo) $rootScope.dashboard.thereAreToDoRunningProjects = true;
                }
                if(response.finished) {
                    if($scope && $scope.runningProjectsTable) $scope.runningProjectsTable.loading = false;
                    $rootScope.dashboard.runningProjects = $rootScope.dashboard.removeDuplicatesAndSort($rootScope.dashboard.dataRunning);
                    $rootScope.dashboard.runningProjectsStandby = $rootScope.dashboard.removeDuplicatesAndSort($rootScope.dashboard.dataRunningStandby);
                }
            }

            $rootScope.dashboard.onResponseClosed = function(response){
                if(response.streamCallN==0){
                    $rootScope.dashboard.dataClosed = [];
                    if($scope && $scope.closedProjectsTable) $scope.closedProjectsTable.loading = true;
                }
                for(var i=0; i<response.length; i++){
                    response[i] = $rootScope.dashboard.modifyProject(response[i])
                    if($rootScope.user.group.type=='SUPPLIER' && response[i].status=='PROCESSING'){

                    } else {
                        $rootScope.dashboard.dataClosed.push(response[i]);
                    }
                }
                if(response.finished) {
                    if($scope && $scope.closedProjectsTable) $scope.closedProjectsTable.loading = false;
                    $rootScope.dashboard.closedProjects = $rootScope.dashboard.removeDuplicatesAndSort($rootScope.dashboard.dataClosed);
                }
            }

            FIREBASE.dashboardFilters = {}

            FIREBASE.timestamps['lastCreationDashboard'] = null
            FIREBASE.listen('Project', 'create', function(value){
                if(value && (value.timestamp!=FIREBASE.timestamps['lastCreationDashboard'] || FIREBASE.timestamps['lastCreationDashboard']===null)){
                    FIREBASE.timestamps['lastCreationDashboard'] = value.timestamp
                    if(FIREBASE.dashboardFilters['open']) D.stream('project', FIREBASE.dashboardFilters['open'], $rootScope.dashboard.onResponseOpen)
                    
                }
            }, null, { doNotUnsubscribe: true, interval: 60000 });
            
            FIREBASE.timestamps['lastChangeDashboard'] = null
            FIREBASE.listen('Project', $rootScope.user.admin ? 'changed' : 'changed_' + $rootScope.user.group.id, function(value){
                if(value && (value.timestamp!=FIREBASE.timestamps['lastChangeDashboard'] || FIREBASE.timestamps['lastChangeDashboard']===null)){
                    FIREBASE.timestamps['lastChangeDashboard'] = value.timestamp
                    if(FIREBASE.dashboardFilters['open']) D.stream('project', FIREBASE.dashboardFilters['open'], $rootScope.dashboard.onResponseOpen)
                    if(FIREBASE.dashboardFilters['running']) D.stream('project', FIREBASE.dashboardFilters['running'], $rootScope.dashboard.onResponseRunning)
                    if(FIREBASE.dashboardFilters['closed']) D.stream('project', FIREBASE.dashboardFilters['closed'], $rootScope.dashboard.onResponseClosed)
                }
            }, null, { doNotUnsubscribe: true, interval: 60000 });
            
            

            

            $scope.loadOpen = function(range, update, t){
                var filter = filters.open;
                if(filter) filter += '&';
                filter += '_range=' + range;
                if(filter) filter += '&';
                filter += '_fields=' + includedFields + ',innerNotes'
                
                $scope.dataOpen = [];
                if(!update) { $rootScope.dashboard.openProjects = []; }
                $scope.dataOpenStandby = [];
                if($rootScope.user.admin){
                    $scope.filesToBeImported = [];
                }
                
                if($rootScope.dashboard.projectFilter=='own' && $rootScope.user.admin){
                    $scope.loadOpenUnassigned(10, update, t);
                }
                D.stream('project', filter,
                    function(response){
                        if(t!=T) return
                        for(var i=0; i<response.length; i++){
                            response[i] = $rootScope.dashboard.modifyProject(response[i])
                            if(response[i].standby){
                                $scope.dataOpenStandby.push(response[i]);
                            } else {
                                $scope.dataOpen.push(response[i]);
                            }
                            if(response[i].toDo) $rootScope.dashboard.thereAreToDoOpenProjects = true;
                        }

                        $scope.dataOpen = $rootScope.dashboard.removeDuplicatesAndSort($scope.dataOpen)
                        $scope.dataOpenStandby = $rootScope.dashboard.removeDuplicatesAndSort($scope.dataOpenStandby)

                        if(!update || response.finished){
                            $rootScope.dashboard.openProjects = $scope.dataOpen;
                            $rootScope.dashboard.openProjectsStandby = $scope.dataOpenStandby;
                            FIREBASE.dashboardFilters['open'] = filter
                        }

                        $timeout(function(){
                            $scope.openProjectsTable.loading = response.finished ? false : true;
                        }, 100);

                    }
                ).catch(console.error);
            };
            $scope.loadOpenUnassigned = function(range, update, t){
                var filter = 'statusgroup=open&assignee=';
                if(filter) filter += '&';
                filter += '_range=' + range;
                if(filter) filter += '&';
                filter += '_fields=' + includedFields + ',innerNotes'
                
                D.stream('project', filter,
                    function(response){
                        if(t!=T) return
                        for(var i=0; i<response.length; i++){
                            response[i] = $rootScope.dashboard.modifyProject(response[i])
                            
                            if(response[i].standby){
                                $scope.dataOpenStandby.push(response[i]);
                            } else {
                                $scope.dataOpen.push(response[i]);
                            }

                            
                        }

                        $scope.dataOpen = $rootScope.dashboard.removeDuplicatesAndSort($scope.dataOpen)

                        if(!update || response.finished){
                            $rootScope.dashboard.openProjects = $scope.dataOpen;
                            FIREBASE.dashboardFilters['openUnassigned'] = filter
                        }
                        
                        $timeout(function(){
                            $scope.openProjectsTable.loading = response.finished ? false : true;
                        }, 100);

                    }
                ).catch(console.error);
            };
            $scope.loadOpen(25, null, T);


            $scope.loadRunning = function(range, update, t){
                var filter = filters.running;
                if(filter) filter += '&';
                filter += '_range=' + range;
                if(filter) filter += '&';
                filter += '_fields=' + includedFields + ',tStatus'
                
                $scope.dataRunning = [];
                if(!update) { $rootScope.dashboard.runningProjects = []; }
                $scope.dataRunningStandby = [];
                
                D.stream('project', filter,
                        function(response){
                            if(t!=T) return
                            for(var i=0; i<response.length; i++){
                                response[i] = $rootScope.dashboard.modifyProject(response[i])
                                if(response[i].standby){
                                    $scope.dataRunningStandby.push(response[i]);
                                } else {
                                    $scope.dataRunning.push(response[i]);
                                }

                                if(response[i].toDo) $rootScope.dashboard.thereAreToDoRunningProjects = true;                                
                            }
                            $scope.dataRunning = $rootScope.dashboard.removeDuplicatesAndSort($scope.dataRunning)
                            $scope.dataRunningStandby = $rootScope.dashboard.removeDuplicatesAndSort($scope.dataRunningStandby)

                            if(!update || response.finished){
                                $rootScope.dashboard.runningProjects = $scope.dataRunning;
                                $rootScope.dashboard.runningProjectsStandby = $scope.dataRunningStandby;
                                FIREBASE.dashboardFilters['running'] = filter
                            }
                            
                            $timeout(function(){
                                $scope.runningProjectsTable.loading = response.finished ? false : true;
                            }, 100);
                                
                        }
                    ).catch(console.error);
            };
            $scope.loadRunning(25, null, T);

            $scope.loadClosed = function(range, update, t){
                var filter = filters.closed;
                if(filter) filter += '&';
                filter += '_range=' + range;
                if(filter) filter += '&';
                filter += '_fields=' + includedFields
                
                $scope.dataClosed = []; 
                if(!update) { $scope.closedProjects = []; }
                
                D.stream('project', filter,
                        function(response){
                            if(t!=T) return
                            for(var i=0; i<response.length; i++){
                                response[i] = $rootScope.dashboard.modifyProject(response[i])
                                
                                if($rootScope.user.group.type=='SUPPLIER' && response[i].status=='PROCESSING'){

                                } else {
                                    $scope.dataClosed.push(response[i]);
                                }
                            }

                            $scope.dataClosed = $rootScope.dashboard.removeDuplicatesAndSort($scope.dataClosed)

                            if(!update || response.finished){
                                $rootScope.dashboard.closedProjects = $scope.dataClosed;
                                FIREBASE.dashboardFilters['closed'] = filter
                            }
                            
                            $timeout(function(){
                                $scope.closedProjectsTable.loading = response.finished ? false : true;
                            }, 100);
                                
                        }
                    ).catch(console.error);
            };
            $scope.loadClosed(100, null, T);


            if($rootScope.user.email=='leonardo@aqrate.biz' || $rootScope.user.email=='test1+leonardo{at}aqrate.biz@aqrate.biz'){
                loadInboundEmails()
                $scope.showInboundEmails = true
            }
        }



    };

    var ieto = null
    $scope.showInboundEmails = false
    $scope.inboundEmails = null
    var loadInboundEmails = function(){
        D.query('inboundEmail','read=false', { cache: false }).then(function(resp){
            $scope.inboundEmails = resp
        }).catch(console.error)
        $timeout.cancel(ieto)
        ieto = $timeout(loadInboundEmails, 60000)
        $scope.inboundEmailsTable = {
            title: 'labels.INBOUNDEMAILS',
            filter: false,
            buttonsOnLeft: true,
            commandButtons: [
                {
                    available: true,
                    cls: 'btn-warning',
                    icon: 'aqi-action-refresh',
                    label: 'fields.REFRESH',
                    onclick: loadInboundEmails
                }
            ],
            fields: [
                {
                    available: true,
                    name: 'T',
                    type: 'date',
                    label: 'DATE',
                    format: 'L LT'
                },{
                    available: true,
                    name: 'from'
                },{
                    available: true,
                    name: 'subject'
                },{
                    available: true,
                    name: 'text'
                },{
                    available: true,
                    type: 'icon',
                    iconType: 'fa',
                    icon: 'aqi-attachment',
                    name: 'attachments',
                    onclick: function(m) {
                        D.query('file', 'type=inboundEmail&entityId=' + m.id).then(function(iefiles){
                            var popupScope = $scope.$new(true)
                            popupScope.files = iefiles
                            popupScope.title = m.subject
                            ngDialog.open({
                                template: '/app/views/entities/file-popuplist.html',
                                className: 'ngdialog-theme-default',
                                scope: popupScope
                            })
                        }).catch(console.error)
                    }
                },{
                    available: true,
                    type: 'click',
                    label: 'EMPTY',
                    isButton: true,
                    icon: 'aqi-action-cancel',
                    buttonClass: 'btn-warning',
                    buttonLabel: 'labels.EMAILNOTAPROJECT',
                    onclick: function(m){
                        ngDialog.openConfirm({
                            template: '/app/views/entities/confirm.html',
                            className: 'ngdialog-theme-default',
                            scope: $scope
                        }).then(function (value) {
                            D.remove('inboundEmail', m.id).then(function(r){
                                loadInboundEmails()
                            }).catch(console.error)
                        })
                    }
                },{
                    available: true,
                    type: 'click',
                    label: 'EMPTY',
                    isButton: true,
                    icon: 'aqi-plus',
                    buttonClass: 'btn-primary',
                    buttonLabel: 'labels.EMAILTOPROJECT',
                    onclick: function(m){
                        $state.go('app.entity', { action:'create', type:'project', filter:'fromInboundEmail=' + m.id })
                    }
                }
            ]
        }
    }

    $scope.expanding = {};
    $scope.expandingfiles = {};
    $scope.expandingprojects = {};
    $scope.expandF = function(name){
        if($scope.expanding[name]) $scope.expanding[name] = '';
        else $scope.expanding[name] = 'loading';
    }
    $scope.expand = function(project){
        if($scope.expanding[project.id]) $scope.expanding[project.id] = '';
        else{
            $scope.expanding[project.id] = 'loading';
            D.query('file','entityId='+project.id+'&field=upload').then(
                function(response){
                    $scope.expandingfiles[project.id] = {};
                    for(var i=0; i<response.length; i++){
                        var f = response[i];
                        var e = f.extension;
                        if(e=='zip' && f.info && f.info.content && f.info.content.length){
                            for(var j=0; j<f.info.content.length; j++){
                                var c = f.info.content[j];
                                if(!c.name.endsWith('/') && c.size!==0 && c.name.indexOf('.')>=0){
                                    if(c.name.indexOf('__MACOSX')===0) continue;
                                    var arr = c.name.split('.');
                                    if(arr[arr.length-2].endsWith('/')) continue; //file senza nome
                                    e = arr.pop().toLowerCase();
                                    if(!$scope.expandingfiles[project.id][e]){
                                        $scope.expandingfiles[project.id][e] = { extension: e, counter: 0};
                                    }
                                    $scope.expandingfiles[project.id][e].counter++;
                                }   
                            }
                        } else {
                            if(!$scope.expandingfiles[project.id][e]){
                                $scope.expandingfiles[project.id][e] = { extension: e, counter: 0};
                            }
                            $scope.expandingfiles[project.id][e].counter++;
                        }
                    }
                }
            ).catch(console.error);
            D.query('project','_similarTo='+project.id+'&statusgroup=open|running').then(
                function(response){
                    $scope.expandingprojects[project.id] = response.sort(function(a,b){
                        return a.ld - b.ld;
                    });
                }
            ).catch(console.error);
        }
    };

    $scope.projectsPopupTable = {
        title: '',
        filter: false,
        style: {
            fontSize: '11px'
        },
        fields: [
            {
                available: true,
                hasLink: true,
                name: 'code',
                label: 'PROJECTCODE',
                style: {
                    minWidth: '100px'
                }
            },{
                available: true,
                hasLink: true,
                name: 'name',
                label: 'PROJECTNAME',
                style: {
                    maxWidth: '300px',
                    wordWrap: 'break-word'
                }
            },{
                available: true,
                label: 'ASSIGNEE',
                name: 'assigneeName'
            },{
                available: true,
                name: 'recoveredWords'
            },{
                available: true,
                name: 'status',
                label: 'PROJECTSTATUS',
                type: 'enum',
                enumType: 'status'
            },{
                available: true,
                name: 'source',
                type: 'enum',
                enumType: 'language'
            },{
                available: true,
                name: 'destinations',
                type: 'enumSet',
                enumType: 'language'
            }
        ],
        link: {
            state: 'app.do',
            action: 'open',
            type: 'project',
            filter: 'id',
            newWindow: true
        }
    };

    $scope.viewSimilarProjects = function(projects){
        $scope.popupProjects = projects;
        ngDialog.open({
            template: '/app/views/entities/projects-popup.html',
            className: 'ngdialog-theme-default ngdialog-theme-large',
            scope: $scope,
            cache: false
          });
        
    }

    $scope.assign = function(project){
        project.action = 'assign';
        project.fromDashboard = true;
        D.save('project', project).then(function(response){
            $scope.expanding[project.id] = ''
        }).catch(function(err){
            if(err.data && err.data.msg && err.data.msg.indexOf('alreadyAssigned')){
                $scope.pop('error', $filter('translate')('labels.ALREADYASSIGNED'));
                $scope.expanding[project.id] = ''
            }
        });
    }

    $scope.import = function(model){
        model.action = 'import'
        D.save('project', model)
            .then(function(resp){
                //project creation => firebase listener => page update
            })
            .catch(function(err){
                model.action = 'importerror'
                model.error = err.data
            })
    }


    $scope.init(new Date().getTime());

    $scope.$on('$destroy', function iVeBeenDismissed() {
        window.removeEventListener('popstate', onPopstate)
      // say goodbye to your controller here
      // release resources, cancel request...
      $scope.loadOpen = function() { };
      $scope.loadRunning = function() { };
      $scope.loadClosed = function() { };


    });
  }
  ]);
